import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logOut } from '../store/user';
import { useDispatch } from 'react-redux';

interface AuthContextProps {
  isAuthenticated: boolean;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);
const { jwtDecode } = require('jwt-decode');

const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const persistedState = localStorage.getItem('persist:root');
    if (persistedState) {
      try {
        const parsedState = JSON.parse(persistedState);
        const userState = JSON.parse(parsedState.user);
        const token = userState.token;

        if (token) {
          try {
            const decodedToken: any = jwtDecode(token);

            const expiry = decodedToken.exp ? decodedToken.exp * 1000 : 0; 
          
            if (Date.now() < expiry) {
              setIsAuthenticated(true);
            } else {
              handleLogout();
            }
          } catch (error) {
            console.error('Error al decodificar el token', error);
            handleLogout();
          }
        } else {
          handleLogout();
        }
      } catch (error) {
        console.error('Error al parsear el estado persistido', error);
        handleLogout();
      }
    } else {
      handleLogout();
    }
  }, []);

  const handleLogout = () => {
    dispatch(logOut());
    localStorage.removeItem('access_token');
    setIsAuthenticated(false);
    
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = (): AuthContextProps => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export { AuthProvider, useAuth };